import * as React from 'react';

import Input from 'components/inputs/input/Input';

import { t } from 'utils/language';

import type { ChangeEvent } from 'react';

type Props = {
  query: string | undefined | null,
  onChange: (a: string) => void
};

class MessengerConversationsSearch extends React.PureComponent<Props> {
  handleInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const { onChange } = this.props;
    const targetValue = event.currentTarget.value || '';

    onChange(targetValue);
  };

  render() {
    const { query } = this.props;

    return (
      <li
        className="messenger-conversations-search"
        data-qa="messenger-conversations-search"
      >
        <div className="messenger-conversations-search__input">
          <Input
            value={query || ''}
            placeholder={t('messenger.conversations_search_placeholder')}
            width="responsive"
            onChange={this.handleInputChanged}
          />
        </div>
      </li>
    );
  }
}

export default MessengerConversationsSearch;
